import React from 'react'
import { useParams } from 'react-router'
import { useStore } from '../../hooks/CompanyConfiguration/useStore'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import StoreView from '../../components/version-4/viewForms/StoreView'
import { ROUTES } from '../../shared/constants'

function ViewStore() {
  const { store, getStore } = useStore()
  const params = useParams()

  React.useEffect(() => {
    getStore({ storeId: params.storeId })
  }, [params.storeId])

  return (
    <Layout heading="Store" heading2="Info" url1={ROUTES.STORE} none>
      {store ? (
        <HeaderTabLayout
          heading="Store"
          content={<StoreView store={store} />}
          view
          url={`/edit-store/${params.storeId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewStore
